module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/footer-logo-ca1276276bdff95e8f50efb1f2e3448b.svg";